export default __webpack_public_path__ + "images/7V.b3470e3.png";